// Turns a tab's display label ("Package Received", "Awaiting Action") into
// a stable URL-friendly slug ("package_received") — used so list pages'
// `?tab=` query param reads as the tab's name instead of a numeric index
// (which meant nothing out of context and broke if tabs were ever
// reordered). Lossy by design (case/punctuation folded away), so it's only
// ever used to look a tab back up by comparing slugs, never displayed.
export const slugifyTab = (label) =>
  String(label || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
